import { message } from 'antd';

// 降级通道：隐藏 textarea + execCommand('copy')
// Clipboard API 在非安全上下文（HTTP 内网 IP 访问后台）与旧浏览器不可用，必须留一条兜底路径
const legacyCopy = (text: string): boolean => {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
};

// 统一复制入口：Clipboard API 失败降级 execCommand，两路都失败才报错，只有真成功才提示已复制
export const copyText = async (text: string, tip = '已复制'): Promise<boolean> => {
  const value = String(text ?? '');
  if (!value) {
    message.error('没有可复制的内容');
    return false;
  }
  let ok = false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      ok = true;
    }
  } catch {
    ok = false;
  }
  if (!ok) {
    ok = legacyCopy(value);
  }
  if (ok) {
    message.success(tip);
  } else {
    message.error('复制失败，请手动选择内容复制');
  }
  return ok;
};
